<template>
  <header class="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">
    <!-- City Dropdown -->
    <div class="flex-1">
      <CitySelector
        :cities="cities"
        :selectedCityKey="selectedCityKey"
        @select="emit('citySelected', $event)"
        @open-change="emit('cityOpenChange', $event)"
      />
    </div>

    <!-- Ramadan Label -->
    <div
      class="flex items-center gap-1.5 text-xs sm:text-sm text-gray-500 dark:text-gray-400"
      :title="ramadanLabel"
    >
      <UIcon name="i-heroicons-moon" class="w-4 h-4" />
      <span class="truncate max-w-[40vw] sm:max-w-none">
        {{ ramadanLabel }}
      </span>
    </div>
  </header>
</template>

<script setup lang="ts">
import CitySelector from "./CitySelector.vue";

type CityOption = { key: string; name: string };

withDefaults(
  defineProps<{
    cities: CityOption[];
    selectedCityKey: string;
    ramadanLabel?: string;
  }>(),
  {
    ramadanLabel: "Ramadan",
  },
);

const emit = defineEmits<{
  (e: "citySelected", city: CityOption): void;
  (e: "cityOpenChange", isOpen: boolean): void;
}>();
</script>
